import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { Confluence, IArea, IRealEstate, IZone } from './interfaces';

export const loadConfluenceMenu = (config?: AxiosRequestConfig) => {
  return instance()
    .get<Confluence.IMenu>(`/confluence/menu`, config)
    .then((response) => response.data);
};

export const searchConfluenceMenu = (config?: AxiosRequestConfig) => {
  return instance()
    .get<Confluence.IMenu>(`/confluence/search`, config)
    .then((response) => response.data);
};

export const loadConfluenceArticle = (id: number) => {
  return instance()
    .get<Confluence.IArticle>(`/confluence/${id}/load`)
    .then((response) => response.data);
};

export const loadConfluenceArticleHistory = (id: number) => {
  return instance()
    .post<Confluence.IArticleHistory>(`/confluence/${id}/history`)
    .then((response) => response.data);
};

export const saveConfluenceDefaultArticle = (article: Confluence.IArticle) => {
  return instance()
    .post(`/confluence/save`, article)
    .then((response) => response.data);
};

export const updateConfluenceDefaultArticle = (article: Confluence.IArticle) => {
  return instance()
    .post(`/confluence/${article.id}/update`, article)
    .then((response) => response.data);
};

export const saveConfluenceLessonArticle = (article: Confluence.ILessonArticle) => {
  return instance()
    .post(`/confluence/${Confluence.ETemplateTypes.LESSON}/save`, article)
    .then((response) => response.data);
};

export const updateConfluenceLessonArticle = (article: Confluence.ILessonArticle) => {
  return instance()
    .post(`/confluence/${Confluence.ETemplateTypes.LESSON}/${article.id}/update`, article)
    .then((response) => response.data);
};

export const saveConfluencePollArticle = (article: Confluence.IPollArticle) => {
  return instance()
    .post(`/confluence/${Confluence.ETemplateTypes.POLL}/save`, article)
    .then((response) => response.data);
};

export const updateConfluencePollArticle = (article: Confluence.IPollArticle) => {
  return instance()
    .post(`/confluence/${Confluence.ETemplateTypes.POLL}/${article.id}/update`, article)
    .then((response) => response.data);
};

export const moveConfluenceArticle = (
  articleId: number,
  parentId: number | null = null,
  section?: Confluence.ESections,
) => {
  return instance()
    .post(`/confluence/${articleId}/changeParent`, { parentId, section })
    .then((response) => response.data);
};

// в ответе — id корневой копии, по нему страница сразу открывает клонированную ветку
export const cloneConfluenceArticle = (
  articleId: number,
  data: { name: string; parentId: number | null; section?: Confluence.ESections },
) => {
  return instance()
    .post<number>(`/confluence/${articleId}/clone`, data)
    .then((response) => response.data);
};

export const showConfluenceArticle = (id: number) => {
  return instance()
    .post(`/confluence/${id}/show`)
    .then((response) => response.data);
};

export const hideConfluenceArticle = (id: number) => {
  return instance()
    .post(`/confluence/${id}/hide`)
    .then((response) => response.data);
};

export const deleteConfluenceArticle = (id: number) => {
  return instance()
    .post(`/confluence/${id}/delete`)
    .then((response) => response.data);
};

export const exportConfluenceArticlePdf = (id: number) => {
  return instance()
    .post<Blob>(`/confluence/${id}/exportPdf`, {}, { responseType: 'blob' })
    .then((response) => response);
};

// Dictionaries
export const getAreas = () => {
  return instance()
    .post<IArea[]>('/area/list', {})
    .then((response) => response.data);
};

export const getRealEstatesShort = (data: {
  areaIds?: number[];
  includeUnserved?: boolean;
  onlyWithKeytransferDate?: boolean;
  includeDeleted?: boolean;
  isNoneService?: boolean;
  onlyFromMatrix?: boolean;
  searchWithCity?: boolean;
  nameWithCity?: boolean;
}) => {
  return instance()
    .post<IRealEstate[]>('/dictionary/v2/realEstatesShort', data)
    .then((response) => response.data);
};

export const getZones = () => {
  return instance()
    .get<IZone[]>('/zone/listAllNotDeleted', {})
    .then((response) => response.data);
};
